import { render, staticRenderFns } from "./Damages.vue?vue&type=template&id=39459dc0&"
import script from "@/views/Reports/Damages/Damages.ts?vue&type=script&lang=ts&"
export * from "@/views/Reports/Damages/Damages.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports